import VTable from '@/vuetify_custom/v-table/v3'
import UserFlowBase from '@/views/components/flow/user_flow_base_jsx_v1'
import VPage from '@/vuetify_custom/v-pagination'
import SearchHeader from '@/views/hr/PaymentManage/SearchHeader.jsx'
import flow_mixins from '@/views/hr/PaymentManage/flow_mixins.js'
import { VBtn} from 'vuetify/lib'
import PayDetail from '@/views/fin/salaryadministration/components/Pay_Detail.jsx'
import del_mixins from '@/views/hr/PaymentManage/salaryFlow/components/del_mixins.jsx'
import { getCustomerSalaryPaymentApplySearchApi } from '@/views/hr/PaymentManage/salaryFlow/service.js'
import { postCustomerSalaryPaymentApplyDeleteApi } from '@/views/fin/salaryadministration/service.js'
export default {
    mixins: [del_mixins, flow_mixins],
    data() {
        this.delApi = postCustomerSalaryPaymentApplyDeleteApi
        return {
            params: {
                total_count:0,
                page: 1,
                per_page: 10,
                status: 'normal',
                search_type: 'pending'
            },
            list: [],
            loading: false,
          //  show_detail: false,
        }
    },
    computed: {
        show_detail() {
            return this.$route.query && this.$route.query.id !== undefined
        },
        cur_customer() {
            return this.$store.state.cur_customer || {};
        },
        field() {
            return [
                {
                    text: '序号',
                    align: 'center',
                    value: 'index',
                    width: 120,
                    render:(_, __, index) => <span>{index + 1}</span>
                },
                {
                    text: '流程名称',
                    align: 'center',
                    value: 'name',
                    render:(_, t) => {
                        return <VBtn color="primary" text on={{
                            click: () => {
                               // this.show_detail = true
                                this.$router.push(`/hr/payment-manage/pay-flow?id=${t.customer_month_salary_total_id}`).then(() => {
                                    this.$refs.detail.getData()
                                })
                            }
                        }}>{t.name}</VBtn>
                    } 
                  //  width: 120,
                },
                {
                    text: '状态',
                    align: 'left',
                    value: 'index',
                    width: 160,
                    render:(_, item) => {
                        return item.user_flow && <UserFlowBase
                            modelC={item}
                            user_flow={item.user_flow || {}}
                            show_handles={true}
                        /> || '-'
                    }
                },
                // {
                //     text: '操作',
                //     align: 'center',
                //     value: 'handle',
                //     type: 'button_g_field',
                //     width: 200,
                //     buttons:({target}) => {
                //         const arr = []
                //         const is_action_type = getsafe(target, 'user_flow.current_user_flow_node.user_flow_node_users.0.action_type') === 'action_type'
                //         const is_my_self = getsafe(target, 'user_flow.current_user_flow_node.user_flow_node_users.0.customer_id') === this.cur_customer.id
                //         const is_not_del = !getsafe(target, 'user_flow.del')
                //         if (is_action_type &&
                //              is_my_self &&
                //               is_not_del) {
                //             arr.push({
                //                 text: '删除',
                //                 key: 'edit',
                //                 color: 'primary',
                //                 _text: true,
                //                 small: true,
                //                 // show: this.params.status === 'edit',
                //                // _text: true,
                //                 callback: (t) => {
                //                     this.del(t).then(this.getListProxy)
                //                 }
                //               })
                //         }
                //         return arr
                //     }
                // },
            ]
        },
    },
    // created() {
    //     const params = this.getParams() || {}
    //     this.params.status = params.status || 'normal'
    //     this.params.search_type = params.search_type || 'pending'
    //     this.$nextTick(this.getListProxy)
    // },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {
            if (this.show_detail) {
                this.$refs.detail.getData()
            } else if (!this.list || !this.list.length) {
                const params = this.getParams() || {}
                this.params.status = params.status || 'normal'
                this.params.search_type = params.search_type || 'pending'
                this.$nextTick(this.getListProxy)
            }
        },
        getListProxy() {
            this.$nextTick(this.getList)
        },
        getList() {
            this.loading = true
            const {status, search_type, ...params} = this.params
            getCustomerSalaryPaymentApplySearchApi(
                {
                    ...params,
                    status: status || undefined,
                    search_type: search_type || undefined
                 }
                ).then(res => {
                this.list = res.list
                this.params.total_count = res.total_count
                this.params.per_page = res.per_page
                this.params.page = res.page
            }).finally(() => {
                this.loading = false
            })
        }   
    },
    render() {
        return <div>
            <div style={{
                display: this.show_detail ? 'none' : 'block' 
            }}>
            <SearchHeader
                v-model={this.params}
                showDataRange
                on={{
                    change: this.getListProxy
                }}
            />
            <VTable
                  loading={this.loading} 
                  headers={this.field}
                  desserts={this.list}
            />
            {!!this.params.total_count && <div class="paginate-fix-bottom">
                <VPage
                    current={this.params.page}
                    total={this.params.total_count}
                    page-size={this.params.per_page}
                    on={ {
                        changePageSize:(per_page) => {
                            this.params.per_page = per_page
                            this.params.page = 1
                            this.getListProxy()
                        },
                        pageChange:(page) => {
                            this.params.page = page
                            this.getListProxy()
                        }
                      }}
                />
                </div>}
            </div>
            <div style={{
                   display: this.show_detail ? 'block' : 'none'
               }}>
                    <PayDetail 
                        ref="detail"
                        showBackTop={false}
                        on={{
                            back:() => {
                             //   this.show_detail = false
                             this.initData()
                            }
                        }}
                    />
           </div>
        </div>
    }
}